import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  animatedContainer: {
    alignItems: 'center',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    width: Theme.px(78),
  },
  circle: {
    backgroundColor: Theme.white,
    borderRadius: Theme.px(15),
    height: Theme.px(30),
    width: Theme.px(30),
  },
  container: {
    backgroundColor: Theme.black,
    borderRadius: Theme.px(30),
    height: Theme.px(30),
    overflow: 'hidden',
    width: Theme.px(71),
  },
  paddingLeft: {
    paddingLeft: Theme.px(18),
  },
  paddingRight: {
    paddingRight: Theme.px(20),
  },
  text: {
    backgroundColor: Theme.transparent,
    color: Theme.white,
    fontSize: Theme.px(30),
    overflow: 'hidden',
  },
  circleStyle: {
    marginLeft: Theme.px(38),
    marginRight: undefined,
  },
  circleStyleValue: {
    marginLeft: undefined,
    marginRight: Theme.px(32),
  },
});
